import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lp-location-finder__list" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "input-group input-group--short" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  class: "lp-location-finder__map",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tag_filter = _resolveComponent("tag-filter")!
  const _component_location_list = _resolveComponent("location-list")!
  const _component_google_map = _resolveComponent("google-map")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["lp-location-finder", $props.cssClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-secondary",
            type: "button",
            "aria-label": "Get location",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.getLocation && $setup.getLocation(...args)))
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "far fa-location" }, null, -1)
          ])),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: $setup.searchPlaceholder,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.SearchManager.SearchInput) = $event)),
            onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.processSearch && $setup.processSearch(...args))),
            "aria-label": "Search locations"
          }, null, 40, _hoisted_4), [
            [_vModelText, $setup.SearchManager.SearchInput]
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fa-solid fa-magnifying-glass search-box-icon" }, null, -1))
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "text-dark my-6 mx-5" }, null, -1)),
        _createVNode(_component_tag_filter, {
          options: $setup.CustomFilterManager.Filters,
          class: "mb-4",
          onOptionClicked: $setup.filterClickHandler
        }, null, 8, ["options", "onOptionClicked"]),
        _createVNode(_component_location_list, {
          "visible-locations": $setup.visibleLocations,
          "details-url": $props.detailsUrl,
          "enable-details": $props.enableDetails,
          center: $setup.lbCenter,
          "filter-by-distance-flag": $setup.filterByDistanceFlag
        }, null, 8, ["visible-locations", "details-url", "enable-details", "center", "filter-by-distance-flag"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_google_map, {
        apiKey: $props.apiKey,
        "initial-marker": false,
        center: $setup.lbCenter,
        markers: $setup.visibleLocations,
        zoom: $props.zoom,
        "zip-code": $setup.SearchManager.SearchInput,
        "fit-map-to-locations": $setup.LocationManager.FitMapToLocations,
        "map-bounds": $setup.LocationManager.MapBounds,
        "details-url": $props.detailsUrl,
        "filter-by-distance-flag": $setup.filterByDistanceFlag,
        onNewCenter: $setup.NewCenterCallback
      }, null, 8, ["apiKey", "center", "markers", "zoom", "zip-code", "fit-map-to-locations", "map-bounds", "details-url", "filter-by-distance-flag", "onNewCenter"])
    ])
  ], 2))
}